import React from "react";
import ContactUsView from "../components/ContactUs/ContactUsView";
import usePageMeta from "../hooks/usePageMeta";

function ContactUs() {
  usePageMeta(
    "Contact Us | Jhatka Byte – Jhatka Mutton Delivery in Kolkata",
    "Contact Jhatka Byte for fresh jhatka mutton orders in Kolkata, Barrackpur and Bardhaman. Call +91 6289560934."
  );
  return <ContactUsView />;
}

export default ContactUs;
